// import React, { useState, useRef, useEffect } from "react";
// import {
//   checkAadhaarAsync,
//   fetchAadhaarDetailsAsync,
//   selectIsOTPVerified,
//   selectOTP,
//   setOTPVerified,
// } from "../property/AadhaarDetailsSlice";
// import { useDispatch, useSelector } from "react-redux";

// const EkycModal = ({ isOpen, onClose, onAadhaarChange }) => {
//   const [aadhaarNumber, setAadhaarNumber] = useState("");
//   const [otp, setOtp] = useState("");
//   const [otpResent, setOtpResent] = useState(false);
//   const [timer, setTimer] = useState(60);
//   const otpTimerRef = useRef(null);
//   const inputs = useRef([]);
//   const dispatch = useDispatch();
//   const storedOTP = useSelector(selectOTP);

//   useEffect(() => {
//     if (otpResent && timer > 0) {
//       otpTimerRef.current = setInterval(() => {
//         setTimer((prev) => prev - 1);
//       }, 1000);
//     } else if (timer === 0) {
//       clearInterval(otpTimerRef.current);
//     }
//     return () => clearInterval(otpTimerRef.current);
//   }, [otpResent, timer]);

//   if (!isOpen) return null;

//   const handleOtpChange = (newOtp) => {
//     setOtp(newOtp);
//   };

//   const handleGetDetails = async () => {
//     try {
//       dispatch(checkAadhaarAsync({ Aadhaar: aadhaarNumber }));
//     } catch (error) {
//       console.error("Error checking Aadhaar:", error);
//     }
//   };

//   const handleSubmitOTP = () => {
//     if (otp !== "" && otp === storedOTP) {
//       ; //////cheeeeeeeeeckc
//       console.log("OTP Verified Successfully");
//       alert("OTP matched!");
//       dispatch(setOTPVerified(true));
//       dispatch(fetchAadhaarDetailsAsync({ Aadhaar: aadhaarNumber }))
//         .then(() => {
//           console.log("Aadhaar details fetched successfully");
//           // onClose(); // Close the modal after fetching details
//         })
//         .catch((error) => {
//           console.error("Error fetching Aadhaar details:", error);
//         });
//     } else {
//       console.error("Invalid OTP");
//     }
//   };

//   const handleInputChange = (index, e) => {
//     const digit = e.target.value.slice(-1);

//     if (/^\d$/.test(digit)) {
//       inputs.current[index].value = digit;
//       for (let i = index + 1; i < inputs.current.length; i++) {
//         if (inputs.current[i].value === "") {
//           inputs.current[i].focus();
//           break;
//         }
//       }
//     } else {
//       inputs.current[index].value = "";
//     }

//     setOtp(inputs.current.map((input) => input.value).join(""));
//   };

//   const handleKeyDown = (index, e) => {
//     if (e.key === "Backspace") {
//       if (inputs.current[index].value === "" && index > 0) {
//         inputs.current[index - 1].focus();
//       } else {
//         inputs.current[index].value = "";
//         e.preventDefault();
//       }
//     }
//   };

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
//       <div className="bg-white rounded-lg p-6 w-full max-w-3xl h-auto">
//         <div className="flex justify-between items-center mb-2">
//           <h2 className="text-xl font-semibold">Aadhaar Verification</h2>
//           <button
//             onClick={(e) => {
//               onClose(e);
//               console.log("Modal close button clicked");
//             }}
//             className="text-gray-600 hover:text-gray-800"
//           >
//             &times;
//           </button>
//         </div>

//         <div className="mb-4">
//           <label className="block text-sm font-semibold mb-2" htmlFor="aadhaar">
//             Aadhaar No.
//           </label>
//           <div className="grid grid-cols-5 gap-4 items-start">
//             <div className="col-span-2">
//               <input
//                 type="text"
//                 id="aadhaar"
//                 value={aadhaarNumber}
//                 // onChange={(e) => setAadhaarNumber(e.target.value)}
//                 onChange={(e) => {
//                   const number = e.target.value;
//                   setAadhaarNumber(number);
//                   onAadhaarChange(number); // Call the parent's callback to send the number
//                 }}
//                 className="custom-input bg-neutral-100"
//                 placeholder="Enter Aadhaar No."
//               />
//             </div>
//             <div className="col-span-1">
//               <button
//                 className="w-full bg-blue-500 text-white py-1 px-4 rounded-md hover:bg-blue-600 text-sm"
//                 onClick={handleGetDetails}
//               >
//                 Get OTP
//               </button>
//             </div>
//           </div>
//         </div>

//         <div className="mb-4 p-4 bg-gray-100 rounded-md">
//           <label className="block text-sm font-medium text-gray-700">
//             <input type="checkbox" className="mr-2" />I Hereby State That I Have
//             No Objection In Authentication Myself With Aadhaar Based
//             Authentication System and Consent to Providing My Aadhaar Number,
//             Biometric and/or One-time Password (OTP) Data for Aadhaar Based
//             Authentication for the Purposes of Availing Benefits of
//             E-registration and E-stamp. I understand That the Aadhaar Number,
//             Biometric and/or OTP I Provide for Authentication Shall Be Used
//             <ol className="list-decimal list-inside ml-4 mt-2">
//               <li>For Authenticating My Identity</li>
//               <li>For Authenticating Property Ownership</li>
//               <li>
//                 For De-Duplication within Verticals of IGRS (Inspector General
//                 of Registration and Stamps) and Other Integrated Departments
//                 (UADD (Directorate of Urban Administration), CLR (Commissioner
//                 Land Records and Settlement))
//               </li>
//             </ol>
//           </label>
//           <label className="block text-sm font-medium text-gray-700">
//             <input type="checkbox" className="mr-2" />I Understand That IGRS
//             (Inspector General of Registration and Stamps), UADD (Directorate of
//             Urban Administration), CLR (Commissioner Land Records and
//             Settlement) and T&CP (Director of Town and Country Planning) shall
//             Ensure Security and Confidentiality of My Personal Identity Data
//             Provided for The Purpose of Aadhaar Based Authentication.
//           </label>
//         </div>

//         <div className="mb-4">
//           <label
//             className="block text-sm font-medium text-gray-700"
//             htmlFor="otp"
//           >
//             Enter OTP
//           </label>
//           <div className="flex items-center space-x-2">
//             <div className="flex space-x-2">
//               {[...Array(6)].map((_, index) => (
//                 <input
//                   key={index}
//                   type="text"
//                   maxLength={1}
//                   className="form-control text-center w-10 border-gray-300 rounded-md shadow-sm"
//                   ref={(el) => (inputs.current[index] = el)}
//                   onChange={(e) => handleInputChange(index, e)}
//                   onKeyDown={(e) => handleKeyDown(index, e)}
//                 />
//               ))}
//             </div>
//             <button
//               className="w-28 h-10 bg-blue-500 text-white py-1 px-4 rounded-md hover:bg-blue-600 text-sm"
//               onClick={handleSubmitOTP}
//             >
//               Submit OTP
//             </button>
//           </div>

//           <div className="text-center mt-2">
//             {otpResent && (
//               <p className="text-sm text-gray-500">
//                 Resend OTP:{" "}
//                 <span>{timer < 10 ? `00:0${timer}` : `00:${timer}`}</span>
//               </p>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default EkycModal;

import React, { useState, useRef, useEffect } from "react";
import {
  checkAadhaarAsync,
  fetchAadhaarDetailsAsync,
  selectOTP,
  setOTPVerified,
} from "../property/AadhaarDetailsSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

const EkycModal = ({ isOpen, onClose, onAadhaarChange }) => {
  const [aadhaarNumber, setAadhaarNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [otpResent, setOtpResent] = useState(false);
  const [timer, setTimer] = useState(60);
  const [checkbox1, setCheckbox1] = useState(false);
  const [checkbox2, setCheckbox2] = useState(false);
  const [error, setError] = useState("");
  const otpTimerRef = useRef(null);
  const inputs = useRef([]);
  const dispatch = useDispatch();
  const storedOTP = useSelector(selectOTP);

  useEffect(() => {
    if (otpResent && timer > 0) {
      otpTimerRef.current = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      clearInterval(otpTimerRef.current);
    }
    return () => clearInterval(otpTimerRef.current);
  }, [otpResent, timer]);

  if (!isOpen) return null;

  // const handleSubmitOTP = () => {
  //   if (otp !== "" && otp === storedOTP) {
  //     console.log("OTP Verified Successfully");
  //     alert("OTP matched!");
  //     dispatch(setOTPVerified(true));
  //     dispatch(fetchAadhaarDetailsAsync({ Aadhaar: aadhaarNumber }))
  //       .then(() => {
  //         console.log("Aadhaar details fetched successfully");
  //       })
  //       .catch((error) => {
  //         console.error("Error fetching Aadhaar details:", error);
  //       });
  //   } else {
  //     console.error("Invalid OTP");
  //   }
  // };
  const handleSubmitOTP = () => {
    if (otp !== "" && otp === storedOTP) {
      console.log("OTP Verified Successfully");
      toast.success("OTP matched!");
      dispatch(setOTPVerified(true));
      dispatch(fetchAadhaarDetailsAsync({ Aadhaar: aadhaarNumber }))
        .then(() => {
          console.log("Aadhaar details fetched successfully");
          // onClose(); // Close the modal after fetching details
        })
        .catch((error) => {
          console.error("Error fetching Aadhaar details:", error);
        });
    } else {
      console.error("Invalid OTP");
      toast.error("Invalid OTP! Please Check");
    }
  };

  const handleInputChange = (index, e) => {
    const digit = e.target.value.slice(-1);
    if (/^\d$/.test(digit)) {
      inputs.current[index].value = digit;
      for (let i = index + 1; i < inputs.current.length; i++) {
        if (inputs.current[i].value === "") {
          inputs.current[i].focus();
          break;
        }
      }
    } else {
      inputs.current[index].value = "";
    }
    setOtp(inputs.current.map((input) => input.value).join(""));
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace") {
      if (inputs.current[index].value === "" && index > 0) {
        inputs.current[index - 1].focus();
      } else {
        inputs.current[index].value = "";
        e.preventDefault();
      }
    }
  };

  const isSubmitDisabled =
    !checkbox1 || !checkbox2 || !/^\d{12}$/.test(aadhaarNumber);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-3xl h-auto">
        <div className="flex justify-between items-center mb-2">
          <h2 className="text-xl font-semibold">Aadhaar Verification</h2>
          <button
            onClick={onClose}
            className="text-gray-600 hover:text-gray-800"
          >
            &times;
          </button>
        </div>

        <div className="mb-4">
          <label className="block text-sm font-semibold mb-2" htmlFor="aadhaar">
            Aadhaar No.
          </label>
          <div className="grid grid-cols-5 gap-4 items-start">
            <div className="col-span-2">
              <input
                type="text"
                id="aadhaar"
                value={aadhaarNumber}
                maxLength={12}
                onChange={(e) => {
                  const number = e.target.value;
                  if (/^\d*$/.test(number) && number.length <= 12) {
                    setAadhaarNumber(number);
                    setError("");
                  } else {
                    setError("Aadhaar must be numeric and 12 digits long");
                  }
                  onAadhaarChange(number);
                }}
                className="custom-input bg-neutral-100"
                placeholder="Enter Aadhaar No."
              />
              {error && <p className="text-red-500 text-sm">{error}</p>}
            </div>
            <div className="col-span-1">
              <button
                className="w-full bg-blue-500 text-white py-1 px-4 rounded-md hover:bg-blue-600 text-sm"
                onClick={() => {
                  if (/^\d{12}$/.test(aadhaarNumber)) {
                    dispatch(checkAadhaarAsync({ Aadhaar: aadhaarNumber }));
                  } else {
                    setError(
                      "Please enter a valid 12-digit Aadhaar number to get OTP"
                    );
                  }
                }}
              >
                Get OTP
              </button>
            </div>
          </div>
        </div>

        <div className="mb-4 p-4 bg-gray-100 rounded-md">
          <label className="block text-sm font-medium text-gray-700">
            <input
              type="checkbox"
              className="mr-2"
              checked={checkbox1}
              onChange={() => setCheckbox1(!checkbox1)}
            />
            I Hereby State That I Have No Objection In Authentication Myself
            With Aadhaar Based Authentication System and Consent to Providing My
            Aadhaar Number, Biometric and/or One-time Password (OTP) Data for
            Aadhaar Based Authentication for the Purposes of Availing Benefits
            of E-registration and E-stamp. I understand That the Aadhaar Number,
            Biometric and/or OTP I Provide for Authentication Shall Be Used
            <ol className="list-decimal list-inside ml-4 mt-2">
              <li>For Authenticating My Identity</li>
              <li>For Authenticating Property Ownership</li>

              <li>
                For De-Duplication within Verticals of IGRS (Inspector General
                of Registration and Stamps) and Other Integrated Departments
                (UADD (Directorate of Urban Administration), CLR (Commissioner
                Land Records and Settlement))
              </li>
            </ol>
          </label>
          <label className="block text-sm font-medium text-gray-700">
            <input
              type="checkbox"
              className="mr-2"
              checked={checkbox2}
              onChange={() => setCheckbox2(!checkbox2)}
            />
            I Understand That IGRS (Inspector General of Registration and
            Stamps), UADD (Directorate of Urban Administration), CLR
            (Commissioner Land Records and Settlement) and T&CP (Director of
            Town and Country Planning) shall Ensure Security and Confidentiality
            of My Personal Identity Data Provided for The Purpose of Aadhaar
            Based Authentication.
          </label>
        </div>

        <div className="mb-4">
          <label
            className="block text-sm font-medium text-gray-700"
            htmlFor="otp"
          >
            Enter OTP
          </label>
          <div className="flex items-center space-x-2">
            <div className="flex space-x-2">
              {[...Array(6)].map((_, index) => (
                <input
                  key={index}
                  type="text"
                  maxLength={1}
                  className="form-control text-center w-10 border-gray-300 rounded-md shadow-sm"
                  ref={(el) => (inputs.current[index] = el)}
                  onChange={(e) => handleInputChange(index, e)}
                  onKeyDown={(e) => handleKeyDown(index, e)}
                />
              ))}
            </div>
            <button
              className={`w-28 h-10 py-1 px-4 rounded-md text-white text-sm ${
                isSubmitDisabled
                  ? "bg-gray-400 cursor-not-allowed"
                  : "bg-blue-500 hover:bg-blue-600"
              }`}
              onClick={handleSubmitOTP}
              disabled={isSubmitDisabled}
            >
              Submit OTP
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EkycModal;
